function ChevronRight() {
  return (
    <svg width={22} height={40} viewBox="0 0 22 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M.95.315L.314.95c-.42.42-.42 1.102 0 1.522L17.845 20 .314 37.53c-.42.42-.42 1.1 0 1.52l.634.635c.42.42 1.102.42 1.522 0L21.395 20.76c.42-.42.42-1.102 0-1.522L2.47.315a1.076 1.076 0 00-1.522 0z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default ChevronRight;
